import { Box, Typography, ToggleButton, Stack } from '@mui/material'
import { Category, Sort, Visibility } from '@mui/icons-material'
import { TpToggleButtonGroup } from '~/components/tp-toggle-button-group'
import { GROUP_STRATEGIES, SORT_STRATEGIES, DATE_OFFSET_STRATEGIES } from '../utils/task-grouping-utils'
import { TpControlTooltip } from '~/components/tp-control-tooltip'

/**
 * Task list sorting, grouping, and date filtering controls
 *
 * Displays three TpToggleButtonGroup components:
 * - Group strategy (None, Type, Org/Crop)
 * - Sort strategy (Date, A-Z, Status)
 * - Date offset (1w, 2w, 1m, 3m, All)
 */
export const TaskListControls = ({
  groupStrategy,
  setGroupStrategy,
  dateOffset,
  setDateOffset,
  dispatch,
  setHoveredTaskGapAction
}) => {
  return (
    <Stack
      direction='row'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        rowGap: 0.5,
        px: 2,
        pt: 1,
        flexWrap: 'wrap'
      }}
    >
      <TpControlTooltip title="Group" placement="bottom" offsetBottom={-6}>
        <TpToggleButtonGroup
          exclusive
          size="small"
          value={groupStrategy}
          onChange={(e, newValue) => {
            if (newValue !== null) setGroupStrategy(newValue)
          }}
        >
          <ToggleButton value={GROUP_STRATEGIES.NONE}>None</ToggleButton>
          <ToggleButton value={GROUP_STRATEGIES.TYPE}>Type</ToggleButton>
          <ToggleButton value={GROUP_STRATEGIES.TARGET}>Location / Crop</ToggleButton>
        </TpToggleButtonGroup>
      </TpControlTooltip>

      <TpControlTooltip title="Filter up to" placement="bottom" offsetBottom={-6}>
        <TpToggleButtonGroup
          exclusive
          size="small"
          value={dateOffset}
          onChange={(e, newValue) => {
            if (newValue !== null) setDateOffset(newValue)
          }}
          onMouseLeave={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: null }))}
        >
          <ToggleButton
            value={DATE_OFFSET_STRATEGIES.NOW}
            onMouseEnter={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: 'now' }))}
          >
            Now
          </ToggleButton>
          <ToggleButton
            value={DATE_OFFSET_STRATEGIES.ONE_WEEK}
            onMouseEnter={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: '1w' }))}
          >
            1w
          </ToggleButton>
          <ToggleButton
            value={DATE_OFFSET_STRATEGIES.TWO_WEEKS}
            onMouseEnter={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: '2w' }))}
          >
            2w
          </ToggleButton>
          <ToggleButton
            value={DATE_OFFSET_STRATEGIES.ONE_MONTH}
            onMouseEnter={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: '1m' }))}
          >
            1m
          </ToggleButton>
          <ToggleButton
            value={DATE_OFFSET_STRATEGIES.ALL}
            onMouseEnter={() => dispatch(setHoveredTaskGapAction({ hoveredTaskGap: 'all' }))}
          >
            All
          </ToggleButton>
        </TpToggleButtonGroup>
        </TpControlTooltip>
    </Stack>
  )
}
